import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=c3032264&"
import script from "./welcome.js?vue&type=script&lang=js&"
export * from "./welcome.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports